import React from "react";
import { ConfigProvider } from "antd";
import CyprusConsultant from "./components/CyprusConsultant";
import "./App.css";

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0284c7",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: 12,
          fontSize: 16,
          colorTextHeading: "#0f172a",
        },
        components: {
          Card: {
            boxShadowTertiary: "0 10px 25px -5px rgba(0, 0, 0, 0.05)",
          },
        },
      }}
    >
      <div className="App">
        {/* HERO HEADER */}
        <header
          style={{
            background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)",
            color: "#fff",
            padding: "60px 24px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Subtle background decoration */}
          <div
            style={{
              position: "absolute",
              top: "-50px",
              left: "-50px",
              width: "200px",
              height: "200px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "50%",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: "-80px",
              right: "-20px",
              width: "300px",
              height: "300px",
              background: "rgba(2, 132, 199, 0.2)",
              borderRadius: "50%",
            }}
          ></div>

          <div
            className="animate-slide-up"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <span
              style={{
                fontSize: "64px",
                filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.2))",
              }}
            >
              🇨🇾
            </span>
            <h1
              style={{
                margin: 0,
                fontSize: "42px",
                fontWeight: 800,
                letterSpacing: "-1px",
                textShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            >
              Du Học Đảo Síp
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: "20px",
                color: "#bae6fd",
                fontWeight: 500,
                maxWidth: "600px",
                lineHeight: 1.6,
              }}
            >
              Cẩm nang học tập & sinh sống toàn diện dành riêng cho sinh viên
              Việt Nam thế hệ {new Date().getFullYear()}.
            </p>
          </div>
        </header>

        {/* MAIN COMPONENT */}
        <main style={{ padding: "40px 20px", minHeight: "60vh" }}>
          <CyprusConsultant />
        </main>

        {/* WARM FOOTER */}
        <footer
          style={{
            textAlign: "center",
            padding: "40px 24px",
            background: "#ffffff",
            color: "#64748b",
            fontSize: "15px",
            borderTop: "1px solid #e2e8f0",
          }}
        >
          <p
            style={{ marginBottom: "12px", fontWeight: 600, color: "#0f172a" }}
          >
            © {new Date().getFullYear()} Tư Vấn Du Học Đảo Síp
          </p>
          <p>
            Hỗ trợ 24/7 hoàn toàn miễn phí:{" "}
            <a
              href="tel:+35794559239"
              style={{
                color: "#0284c7",
                fontWeight: 700,
                textDecoration: "none",
                display: "inline-block",
                padding: "4px 12px",
                background: "#f0f9ff",
                borderRadius: "20px",
                marginLeft: "8px",
              }}
            >
              📱 +357 9455 9239
            </a>
          </p>
        </footer>
      </div>
    </ConfigProvider>
  );
};

export default App;
